
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResizeBottom as ObiResizeBottomElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resize-bottom.js';
 
 
 

 
 export const ObiResizeBottom = createComponent({
   react: React,
   tagName: 'obi-resize-bottom',
   elementClass: ObiResizeBottomElement,
   events: {
     
   }
  });
 
 